import React from 'react';

function MichassFooter() {
	return (
		<div className="flex flex-col w-full justify-center px-16" id="michass-footer-bg">
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-2 py-8 mx-auto">
				<div className="flex flex-col col-span-2">
					<p className="border-b mr-2 text-xl">Notre église</p>
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-2">
						<ul className="">
							<li>* Abidjan Yopougon Maroc</li>
							<li>* infos@eglisemichass.ci</li>
							<li>* +225 07 074 915 69</li>
							<li className="flex flex-wrap items-center mt-2">
								<svg className="w-[24px] h-[24px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
									<path fill-rule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clip-rule="evenodd"/>
								</svg>
								<svg className="w-[24px] h-[24px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
									<path fill-rule="evenodd" d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964 2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.836 2.836 0 0 0-1.983.839 4.225 4.225 0 0 0-.79 1.965 30.146 30.146 0 0 0-.2 3.206v1.5a30.12 30.12 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972.604.536 1.38.837 2.187.848 1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.844 2.844 0 0 0 1.985-.84 4.27 4.27 0 0 0 .787-1.965 30.12 30.12 0 0 0 .2-3.206v-1.516a30.672 30.672 0 0 0-.202-3.206Zm-11.692 6.554v-5.62l5.4 2.819-5.4 2.801Z" clip-rule="evenodd"/>
								</svg>
							</li>
						</ul>
						<ul className="">
							<li>Historique</li>
							<li>Notre mission</li>
							<li>La communauté chrétienne</li>
							<li>Enseignements</li>
						</ul>
					</div>
				</div>
				<div className="">
					<p className="mb-2 border-b text-xl">Rejoignez-nous</p>
					<div className="flex items-center justify-center">
						<iframe className="border-0 w-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d127115.39218786401!2d-4.16467626936414!3d5.362539431780779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc1c10043180dc1%3A0x317057e5a4730b08!2sMICHASS%20(Mission%20Internationale%20Chr%C3%A9tienne%20d&#39;Aide%20Spirituelle%20et%20Sociale)!5e0!3m2!1sfr!2sci!4v1709859126267!5m2!1sfr!2sci" allowfullscreen="true" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
					</div>	
				</div>
			</div>
			<hr className="text-white my-3 mx-16" />
			<div className="flex justify-center items-center mb-3">
				Copyright Mai 2024 - Tous droits reservés
			</div>
		</div>
	);
}

export default MichassFooter;
